import React from "react";
import styles from "./Counter.module.scss";

interface ICounterProps {
  children?: number | undefined | null;
}

export const Counter = ({ children: count = 0 }: ICounterProps) => {
  if (count === 0 || !count) {
    return null;
  }

  return (
    <p
      className={styles.counter}
      data-testid="header__cart--counter"
      role="status"
      aria-live="polite"
    >
      {count > 99 ? "99+" : count}
    </p>
  );
};
